import React from 'react';
import { Helmet } from 'react-helmet';
import config from 'sharedConfig';

export default function CategoryGroupHeadTags(props) {
  const categories = props.categories;
  const pageTitle = props.title;
  const description = (categories.length === 1 && categories[0].description) ?
    categories[0].description :
    'Online Shopping from a great selection at ' + props.title + '. Delivered in 30 minutes.';

  let nameParam = props.nameParam;
  if (typeof window !== 'undefined') {
    const pathname = window.location.pathname.slice(1);
    if (pathname === 'wine') nameParam = 'wine';
    if (pathname === 'spirits') nameParam = 'spirits';
    if (pathname === 'more') nameParam = 'more';
  }

  const url = [config.site.url, props.url].join('');

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="title" content={pageTitle} />
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
    </Helmet>
  );
}



// WEBPACK FOOTER //
// ./shared/components/categoryGroup/head.js